<script>
import InputMask from '../__components/InputMask.vue';
import DatePicker from '../__components/DatePicker.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    InputMask,
    DatePicker,
  },
  props: {
    value: {
      type: Date,
    },
  },
};
</script>
<template>
  <div class="f-flex">
    <InputMask
      class="f-flex__auto"
      type="typed"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :options="module.options"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @submit="$emit('submit', $event)"
    />
    <DatePicker
      v-if="module.picker"
      :value="value"
      :min="module.options.min"
      :max="module.options.max"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </div>
</template>
